import { render, staticRenderFns } from "./AupairList.vue?vue&type=template&id=168ddd40&"
import script from "./AupairList.vue?vue&type=script&lang=js&"
export * from "./AupairList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports